import { UploadExcelWorkbookManager } from "../Exporters/ManagersExporter";
import { EventDispatcher } from "strongly-typed-events";

export class SideBarManager {

    constructor(private containerElement: JQuery) { }

    public workbookSetFromSideBar = new EventDispatcher<SideBarManager, undefined>();

    public initialize() {
        var self = this;
 
        self.containerElement.find('.toggle-btn').off('click').on('click', () => {
            self.containerElement.toggleClass('expand');
        });

        var uploadWorkbookManager = new UploadExcelWorkbookManager(self.containerElement);
        uploadWorkbookManager.initialize();

        uploadWorkbookManager.workbookSetEvent.subscribe(() => {
            var pathName = location.pathname;
            if(pathName != '/Company/Excel/Upload') {
                location.pathname = '/Company/Excel/Upload'
            }

            self.workbookSetFromSideBar.dispatch(this, undefined);
        })
    }
}